import ReportsSerializer from '@linc-technologies/linced-common/serializers/reports/base';

export default class RubricCriteria extends ReportsSerializer {
  payloadKeyFromModelName() {
    return 'rubricCriteria';
  }

  modelNameFromPayloadKey() {
    return 'reports/rubric-criteria';
  }
}
